// src/redux/slices/layerSlice.js
import { createSlice } from '@reduxjs/toolkit';

const layerSlice = createSlice({
  name: 'layers',
  initialState: {
    allLayers: [],
    activeLayerName: '0', // Default layer
  },
  reducers: {
    setLayers: (state, action) => {
      state.allLayers = action.payload;
    },
    setActiveLayerName: (state, action) => {
      state.activeLayerName = action.payload;
    },
    clearLayers: (state) => {
      state.allLayers = [];
      state.activeLayerName = '0';
    },
    updateLayerColor: (state, action) => {
      const { layerName, color } = action.payload;
      const layer = state.allLayers.find(l => l.name === layerName);
      if (layer) {
        layer.color = color;
      }
    },
    updateLayerProperty: (state, action) => {
      const { layerName, property, value } = action.payload;
      const layer = state.allLayers.find(l => l.name === layerName);
      if (layer) {
        layer[property] = value;
      }
    },
    toggleLayerOnOff: (state, action) => {
      const layerName = action.payload;
      const layer = state.allLayers.find(l => l.name === layerName);
      if (layer) {
        // Mevcut durumu belirle: undefined veya true = görünür (true), false = gizli (false)
        const currentState = layer.onOff !== false;
        // Toggle et
        layer.onOff = !currentState;
        // visible property'sini de güncelle (dxf-parser bunu kullanıyor)
        layer.visible = layer.onOff;
      }
    },
  },
});

export const { setLayers, clearLayers, setActiveLayerName, updateLayerColor, updateLayerProperty, toggleLayerOnOff } = layerSlice.actions;
export default layerSlice.reducer;
